import { SVGProps } from 'react';

const SvgWarning = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M12 9a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M11.989 4.002c-.012.003-.033.013-.05.044L3.018 19.8a.157.157 0 0 0-.019.077c0 .047.017.08.037.1.02.02.034.023.044.023h17.838a.051.051 0 0 0 .026-.008.118.118 0 0 0 .05-.075.158.158 0 0 0-.015-.117L12.061 4.046a.105.105 0 0 0-.034-.038.052.052 0 0 0-.021-.008c-.005 0-.01 0-.017.002Zm-1.791-.94a2.059 2.059 0 0 1 2.871-.76c.307.187.557.45.733.76l8.919 15.753c.56.99.256 2.279-.733 2.883-.321.197-.69.302-1.07.302H3.082C1.896 22 1 21.013 1 19.877c0-.371.095-.738.279-1.062L10.198 3.06Z"
      clipRule="evenodd"
    />
    <circle cx={12} cy={16} r={1} fill="#081930" />
  </svg>
);

export default SvgWarning;
